/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Banner_Capabilities_Bind_All_TitleInputs */



/**
* | output |
* | --- |
* | "Capabilities apply to administrators too" |
*
* @param {Rights_Banner_Capabilities_Bind_All_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_banner_capabilities_bind_all_title = /** @type {((inputs?: Rights_Banner_Capabilities_Bind_All_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Banner_Capabilities_Bind_All_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen gelten auch für Administratoren")
	return /** @type {LocalizedString} */ ("Capabilities apply to administrators too")
});